import { atom } from 'recoil';

export const CartState = atom({
    key: "cartState",
    default: []
})